import React, { useState, useEffect } from 'react';
import PartsList from './PartsList'
import '../css/app.css'
import uuidv4 from 'uuid/v4'
import PartsEdit from './PartsEdit';

export const PartsContext = React.createContext()
const LOCAL_STORAGE_KEY = 'dbcsParts.parts'

function App() {
  const [selectedPartId, setSelectedPartId] = useState()
  const [parts, setParts] = useState(sampleParts)
  const selectedPart = parts.find(part => part.id === selectedPartId)
  
  useEffect(() => {
    const partJSON = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (partJSON != null) setParts(JSON.parse(partJSON))
  }, [])

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(parts))
  }, [parts])

  const partContextValue = {
    handlePartAdd,
    handlePartDelete,
    handlePartSelect,
    handlePartChange
  }

  function handlePartSelect(id) {
    setSelectedPartId(id)
  }

  function handlePartAdd() {
    const newPart = {
      id: uuidv4(),
      nomenclature: '',
      stockNumber: '',
      location: '',
      reference: ''
    }

    setSelectedPartId(newPart.id)
    setParts([...parts, newPart])
  }

  function handlePartChange(id, part) {
    const newParts = [...parts]
    const index = newParts.findIndex(p => p.id === id)
    newParts[index] = part
    setParts(newParts)
  }

  function handlePartDelete(id) {
    if (selectedPartId != null && selectedPartId === id) {
      setSelectedPartId(undefined)
    }
    setParts(parts.filter(part => part.id !== id))
  }

  return (
    <PartsContext.Provider value={partContextValue}>
      <PartsList parts={ parts } />
      {selectedPart && <PartsEdit part={selectedPart} />}
    </PartsContext.Provider>
  )
}

const sampleParts = [
  {
    id: 1,
    nomenclature: 'Bottom Belt Feed Table',
    stockNumber: '3030-00-16-0087',
    location: 'B5-2-4-E',
    reference: "MS-354, Figure-2, Index-12"
  },
  {
    id: 2,
    nomenclature: 'Crown Roller',
    stockNumber: '3030-00-16-0087',
    location: 'B5-2-4-E',
    reference: "MS-354, Figure-2, Index-12"
  }
]

export default App;